import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from 'uuid';
interface IGridState {
  gridUpdateTrigger: string;
}

const initialState: IGridState = {
  gridUpdateTrigger: "",
};

export const gridSlice = createSlice({
  name: "grid",
  initialState,
  reducers: {
    setGridUpdateTrigger: (state) => {
      state.gridUpdateTrigger = uuidv4();
    },
  },
});

export const { setGridUpdateTrigger } = gridSlice.actions;

export const selectGridUpdateTrigger = (state: { grid: IGridState }) =>
  state.grid.gridUpdateTrigger;

export const grid = gridSlice.reducer;
